import React from 'react'
import styled, { css } from 'styled-components/macro'
import PropTypes from 'prop-types'
import { Text } from 'components/atoms'

const Error = ({ message, code, helper }) => (
  <Wrapper>
    <h1>{code}</h1>
    <div className="message">
      <h2>{message}</h2>
      {typeof helper === 'string'
        ? <Text modifiers="xs">{helper}</Text>
        : helper
      }
    </div>
  </Wrapper>
)

Error.propTypes = {
  message: PropTypes.string,
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  helper: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
}

Error.defaultProps = {
  message: 'Algo correu mal.',
  code: 'Erro',
  helper: <Text modifiers="xs">Contacte o UA LAbs com este URL ou recarregue a página.</Text>,
}

const Wrapper = styled.div(props => css`
  display: flex;
  align-items: center;
  justify-content: center;
  h1 {
    display:inline-block;
    border-right: 1px solid ${props.theme.colors.border};
    margin:0;
    margin-right: ${props.theme.spacing.m};
    padding:10px 23px 10px 0;
    font-size: ${props.theme.sizes.xl3};
    font-weight: ${props.theme.weight.base};
    vertical-align:top
  }
  h2 {
    font-size: ${props.theme.sizes.s};
    font-weight: ${props.theme.weight.xbase};
    margin:0;
    padding:0
    padding-bottom: ${props.theme.spacing.xs4};
  }
  .message {
    display:inline-block;
    text-align:left;
    vertical-align:middle;
    max-width: 300px;
  }
`)

export default Error
